module.exports = __webpack_public_path__ + "img/logo-sdg.cf771b69.png";